export interface RelationshipRating {
  score: number
  review?: string
  ratedAt: string
}

export interface Relationship {
  id: string
  mentorId: string
  menteeId: string
  status: RelationshipStatus
  requestedAt: string
  acceptedAt?: string
  completedAt?: string
  notes?: string
  // Rating the mentor received from the mentee
  mentorRating?: RelationshipRating
  // Rating the mentee received from the mentor
  menteeRating?: RelationshipRating
  mentor?: {
    id: string
    firstName: string
    lastName: string
    email: string
    profile: {
      bio?: string
      expertise: string[]
      profilePicture?: string
    }
  }
  mentee?: {
    id: string
    firstName: string
    lastName: string
    email: string
    profile: {
      interests: string[]
      goals: string[]
      profilePicture?: string
    }
  }
}

export enum RelationshipStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export interface MatchingRequest {
  id: string
  menteeId: string
  mentorId: string
  message: string
  status: MatchingRequestStatus
  createdAt: string
  mentee?: {
    id: string
    firstName: string
    lastName: string
    email: string
    averageRating?: number
    totalReviews?: number
    profile: {
      interests: string[]
      goals: string[]
      profilePicture?: string
    }
  }
}

export enum MatchingRequestStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined'
}

export interface CreateMatchingRequestData {
  mentorId: string
  message: string
}

export interface MentorSearchFilters {
  expertise?: string[]
  search?: string
  page?: number
  limit?: number
}

export interface AvailableMentor {
  id: string
  firstName: string
  lastName: string
  email: string
  bio: string
  expertise: string[]
  isAvailable: boolean
  isFull: boolean
  matchScore: number
  currentMentees: number
  maxMentees: number
  profilePicture?: string
  averageRating?: number
  totalReviews?: number
}

export interface SuggestedMentee {
  id: string
  firstName: string
  lastName: string
  interests: string[]
  goals: string[]
  matchScore: number
  averageRating?: number
  totalReviews?: number
  profilePicture?: string
}